import FastMarquee from 'react-fast-marquee';

const ITEMS = ['72 Species', '18 Tribes', 'Family Asteraceae', 'Western Vidarbha', 'Doctoral Research', 'Est. MMXXVI'];

export const EditorialMarquee = () => (
    <div data-testid="editorial-marquee" className="overflow-hidden border-b border-line bg-sand/50 py-7">
        <FastMarquee speed={28} gradient={false} pauseOnHover>
            {ITEMS.concat(ITEMS).map((item, i) => (
                <span key={i} className="mx-8 flex items-center gap-16 font-serif text-3xl italic text-ink/75 md:text-5xl">
                    {item}
                    <span className="text-terra" aria-hidden="true">❋</span>
                </span>
            ))}
        </FastMarquee>
    </div>
);
